import React from 'react';
import { useI18n } from '@udemy/i18n';
import { useUDData } from '@udemy/ud-data';
import { BrowseNavDropdown } from '../../desktop/browse/browse-nav-dropdown.react-component';
import styles from "../../desktop/desktop-header.module.css";
import { HeaderButton } from '../../desktop/header-dropdown.react-component';
import { useHeaderStore } from '../../hooks/use-header-store';
export const BrowseButtons = () => {
  const headerStore = useHeaderStore();
  const {
    Config
  } = useUDData();
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BrowseNavDropdown, {
    className: styles['gap-button']
  }), Config.features.organization.learning_path.enabled && /*#__PURE__*/React.createElement("div", {
    className: styles['gap-button group-a']
  }, /*#__PURE__*/React.createElement(HeaderButton, {
    componentClass: "a",
    href: headerStore.urls.LEARNING_PATHS
  }, gettext('Learning paths'))));
};
//# sourceMappingURL=browse-buttons.react-component.js.map